<template>
  <lazy-theme8-base-not-found
    :is-full-screen-error="true"
    :background-color="vars.backgroundColor"
  >
    <template #title>
      <!-- Ana Container -->
      <div 
        class="tw-relative tw-w-full tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-px-4"
        :style="{
          backgroundImage: `url(${vars.photoImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }"
      >
        
        <!-- İçerik -->
        <div class="tw-relative tw-z-10 tw-text-center tw-text-white tw-max-w-4xl tw-mx-auto">
          <!-- 404 Başlık -->
          <div class="tw-mb-8">
            <h1 class="tw-text-8xl md:tw-text-9xl lg:tw-text-[12rem] tw-font-bold tw-tracking-wider tw-text-white tw-drop-shadow-2xl">
              404
            </h1>
          </div>
          
          <!-- Alt Başlık -->
          
          
          <!-- Açıklamalar -->
          <div v-if="descriptions && descriptions.length" class="tw-mb-12 tw-max-w-2xl tw-mx-auto">
            <h6
              v-for="(item, idx) in descriptions"
              :key="`notfound-desc-${idx}`"
              class="tw-text-gray-200 tw-text-lg tw-mb-3 tw-leading-relaxed"
            >
              {{ item.description }}
          </h6>
          </div>
          
          <!-- Ana Sayfa Butonu -->
          <div class="tw-mt-8">
           <nuxt-link v-if="vars.buttonLinkUrl"
                 :external="true"
                 :to="vars.buttonLinkUrl"
                 :class="`n-${vars.buttonTypeText} n-btn tw-mt-2`">
        <div class="n-btn-container">
          <div class="n-btn-group">
            <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          </div>
        </div>
      </nuxt-link>
          </div>
        </div>
      </div>
    </template>
  </lazy-theme8-base-not-found>
</template>



<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'NotFoundPage',

  mixins: [ComponentMixin],

  setup() {
    const event = useRequestEvent();

    // event will be undefined in the browser
    if (event) {
      // Set the status message as well
      setResponseStatus(event, 404, 'Page Not Found');
    }
  },

  

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>

